import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CmsLineBreaker } from '@common/infrastructure/cms-line-breaker';

@Pipe({ name: 'jpText',
    standalone: false
})
export class JpTextPipe implements PipeTransform {
    constructor() { }

    transform(input: Observable<string>): Observable<string> {
        return input.pipe(
            map(val => {
                return CmsLineBreaker.insertLineBreaks(val);
            })
        );
    }
}
